document.addEventListener('DOMContentLoaded', function () {
    /// --- main navigation ---///
    const openNavBtn = document.querySelector('#show-main-nav');
    const closeNavBtn = document.querySelector('#close-main-nav');
    const mainNavId = document.querySelector('#main-nav');
	let menuIsOpened = false;


    openNavBtn.addEventListener("click", () => {
		if ( menuIsOpened ) {
			closeMenu();
		} else {
			openMenu();
		}
    } );

    closeNavBtn.addEventListener("click", closeMenu );

	function openMenu () {
		mainNavId.classList.add('opened');
		document.body.classList.add( 'navigation-opened' );
		menuIsOpened = true;
	}

	function closeMenu () {
		mainNavId.classList.remove('opened');
		document.body.classList.remove( 'navigation-opened' );
		menuIsOpened = false;
	}

	document.body.addEventListener( 'click', e => {
		if ( ! menuIsOpened ) {
			return true;
		}

		if ( ! e.srcElement.closest( '#main-nav' ) && ! e.srcElement.closest( '#show-main-nav' ) ) {
			e.preventDefault();
			closeMenu();
		}
	} );

	/// ---- carousel ----/

    const sliderElement = document.getElementById("home-carousel")
    let interval = 0

    function autoplay(run) {
        clearInterval(interval)
        interval = setInterval(() => {
            if (run && slider) {
                slider.next()
            }
        }, 5000)
    }

    if (typeof(sliderElement) != 'undefined' && sliderElement != null) {
        const otslider = new OTSlider();
        otslider.init({
            element: sliderElement,
            transition: 'fade',
            duration: 3000,
            transitionDuration: 1000,
            pauseOnHover: false,
            showPrevNext: false,
            showNav: false,
	        swipe: false,
        });

		let deltaX;
		let deltaY;
		let startX;
		let endX;
		let startY;
		let endY;

		function touchStartCb ( event ) {
			startX = event.changedTouches[0].clientX;
			startY = event.changedTouches[0].clientY;
		}

		function touchEndCb ( event ) {
			endX = event.changedTouches[0].clientX;
			endY = event.changedTouches[0].clientY;

			deltaX = endX - startX;
			deltaY = endY - startY;

			if ( Math.abs( deltaX ) / Math.abs( deltaY ) < 3 ) {
				return;
			}

			event.preventDefault();

			if ( deltaX > 0 ) {
				otslider.prevItem();
			} else {
				otslider.nextItem();
			}
		}

		sliderElement.addEventListener( 'touchstart', touchStartCb );
		sliderElement.addEventListener( 'touchend', touchEndCb );
    }

    /// ---- carousel end ----/


    solutions();
    profiles();

}, false);

const solutions = () => {
    let solutionsBtn = document.querySelectorAll('.js-solution');

    for (let i = 0; i < solutionsBtn.length; i++) {
        solutionsBtn[i].addEventListener('click', function () {
            solutionsBtnClick(event);
        });
    }
}

const solutionsBtnClick = (e) => {
    let btnClicked = e.target;
    let description = btnClicked.nextElementSibling;

    if (!description.style.maxHeight) {
        let allDescriptions = document.querySelectorAll('.js-description');
        for (let i = 0; i < allDescriptions.length; i++) {
            if (allDescriptions[i].style.maxHeight) {
                allDescriptions[i].style.maxHeight = null;
                allDescriptions[i].previousElementSibling.innerHTML = "+";
            }
        }

        description.style.maxHeight = description.scrollHeight + "px";
        btnClicked.innerHTML = "-";
    } else {
        description.style.maxHeight = null;
        btnClicked.innerHTML = "+";

    }
}

// slide left right animation
const scrollElements = document.querySelectorAll(".js-scroll");

const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
    );
};


const displayScrollElement = (element) => {
    element.classList.add("scrolled");
};

const handleScrollAnimation = () => {
    [].forEach.call(scrollElements, (el) => {
        if (elementInView(el, 1.25)) {
            displayScrollElement(el);
        }
    });
}

window.addEventListener("scroll", () => {
    handleScrollAnimation();
});

window.addEventListener("resize", () => {
    handleScrollAnimation();
});

document.addEventListener('DOMContentLoaded', () => {
    handleScrollAnimation();
});

const profiles = () => {
    let profilesBtn = document.querySelectorAll('.js-profile-btn');

    for (let i = 0; i < profilesBtn.length; i++) {
        profilesBtn[i].addEventListener('click', function (e) {
            let profileContainer = e.target.closest('.profile');
            let profileContent = profileContainer.querySelector('.profile__content');

            profileContainer.classList.toggle('profile--opened');

            if (!profileContent.style.maxHeight) {
                let allProfileContent = document.querySelectorAll('.profile__content');
                for (let i = 0; i < allProfileContent.length; i++) {
                    if (allProfileContent[i].style.maxHeight) {
                        allProfileContent[i].style.maxHeight = null;
                        allProfileContent[i].closest('.profile').classList.remove('profile--opened');
                    }
                }

                profileContent.style.maxHeight = profileContent.scrollHeight + "px";
            } else {
                profileContent.style.maxHeight = null;
            }
        });
    }
}
